<div class="page-container">
  <div class="container">
    <mat-card class="profile-card">
      <div class="profile-card-header">
        <div class="profile-card-header-spacer" aria-hidden="true"></div>
        <div class="profile-card-header-text">
          <div class="profile-card-title-row">
            <mat-icon class="profile-title-icon">person</mat-icon>
            <span class="profile-card-title">User Profile</span>
          </div>
          <p class="profile-card-subtitle">Your account details</p>
        </div>
        <div class="profile-card-header-spacer" aria-hidden="true"></div>
      </div>

      <mat-card-content class="profile-card-body">
        <div *ngIf="loading" class="loading-section">
          <p>Loading profile...</p>
        </div>

        <div *ngIf="error && !loading" class="error-section">
          <mat-icon color="warn">error</mat-icon>
          <p>{{ error }}</p>
        </div>

        <div *ngIf="user && !loading" class="user-info">
          <div class="info-row">
            <span class="info-label">Username</span>
            <span class="info-value">{{ displayUsername(user) }}</span>
          </div>

          <div class="info-row">
            <span class="info-label">Email</span>
            <span class="info-value">{{ user.email }}</span>
          </div>

          @if (showTextNotifications) {
            <div class="info-row">
              <span class="info-label">Text notifications</span>
              <span class="info-value text-notifications-value">
                {{ textNotificationsLabel(user) }}
                @if (showPhoneVerifiedCheckmark(user)) {
                  <mat-icon class="phone-verified-icon" aria-label="Phone verified">check_circle</mat-icon>
                }
              </span>
            </div>
          }
        </div>

        <div *ngIf="!user && !loading && !error" class="no-data">
          <mat-icon>person</mat-icon>
          <p>No user information available</p>
        </div>
      </mat-card-content>

      <mat-card-actions class="profile-actions">
        <div class="profile-actions-row">
          <button mat-raised-button color="primary" routerLink="/userhome" type="button">
            <mat-icon>home</mat-icon>
            Back to Home
          </button>

          @if (showSettingsLink) {
            <button mat-raised-button color="primary" routerLink="/settings" type="button">
              <mat-icon>{{ settingsButtonIcon }}</mat-icon>
              {{ settingsButtonLabel }}
            </button>
          }

          <button mat-raised-button color="warn" type="button" (click)="logout()">
            <mat-icon>logout</mat-icon>
            Logout
          </button>
        </div>

        @if (showSettingsLink) {
          <p class="settings-hint">{{ settingsHint }}</p>
        }
      </mat-card-actions>
    </mat-card>
  </div>
</div>
